import { HorizontalContainer, Wrapper } from '@american-autonomy/ag-ui';

import Grid from 'components/Grid';
import TriangleArrowIcon from 'components/icons/TriangleArrowIcon';

import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const WithHierarchy: FunctionComponent<Props> = ({
    children,
    hasChildren = false,
    indent = 0,
    index,
    isLast = [],
    isOpen = false,
    onClick,
    parentId,
    rowId,
    rows = []
}) => {
    const expandClasses = [];

    const openClass = isOpen ? styles.open : '';

    if (rows[rows.length - 1].id !== rowId) {
        if (index === 0 && parentId) {
            expandClasses.push(styles.childExpander);
        } else {
            expandClasses.push(styles.multiExpander);
        }
    } else if (rows[rows.length - 1].id === rowId) {
        if (index === 0 && parentId) {
            expandClasses.push(styles.lastChildExpander);
        }
    }

    return (
        <Grid className={styles.grid} onClick={onClick}>
            <HorizontalContainer className={styles.horizontalContainer}>
                <div />

                {[...Array(indent)].map((_, index) => (
                    <div
                        className={`${isLast[index] ? styles.hide : ''} ${styles.indent}`}
                        key={`indent-${index}`}
                    />
                ))}
            </HorizontalContainer>

            <div className={`${expandClasses.join(' ')} ${styles.expander}`}>
                {hasChildren && (
                    <TriangleArrowIcon className={`${openClass} ${styles.triangleArrowIcon}`} />
                )}
            </div>

            <Wrapper className={styles.icon} />

            {children}
        </Grid>
    );
};

export default WithHierarchy;
